module.exports = __webpack_public_path__ + "static/img/p1.cc822f0f.png";